import { Command as CommandPrimitive } from 'cmdk'
import type React from 'react'
import { cn } from '@/src/utils/styles'

export const SearchCommand = ({
  className,
  shouldFilter,
  loop,
  isOpen,
  value,
  onValueChange,
  ...props
}: React.ComponentPropsWithoutRef<typeof CommandPrimitive> & {
  shouldFilter?: boolean
  loop?: boolean
  isOpen: boolean
  value?: string
  onValueChange?: (value: string) => void
}) => (
  <div
    className={cn(
      'flex flex-col w-full justify-start overflow-hidden sm:rounded-3xl', // base styles
      className,
    )}
  >
    <CommandPrimitive
      className={cn(className)}
      shouldFilter={shouldFilter}
      loop={loop}
      value={value}
      onValueChange={onValueChange}
      {...props}
    />
  </div>
)
